import { compose } from '@ngrx/core';
import { combineReducers } from '@ngrx/store';

import { batchReducers } from './batches';
import { binsReducers } from './bins';
import { dieReducers } from './dies';
import { eodReducers } from './eod';
import { holdReducers } from './holds';
import { horizonReducers } from './horizons';
import { horizonStatReducers } from './horizonStats';
import { jobReducers } from './jobs';
import { mainViewReducers } from './main';
import { notificationReducers } from './notifications';
import { orderReducers } from './orders';
import { preAuthReducers } from './pre-auth';
import { printerReducers } from './printers';
import { productReducers } from './products';
import { reportReducers } from './reports';
import { scrapReducers } from './scrap';
import { shipmentReducers } from './shipments';
import { settingReducers } from './settings';
import { templateReducers } from './templates';
import { userReducers } from './users';
import { holdBinsReducers } from './holdBins';
import { jobLocationsReducers } from './jobLocations';
import { roleReducers } from './roles';

const reducers = {
  batches      : batchReducers,
  bins         : binsReducers,
  dies         : dieReducers,
  eod          : eodReducers,
  holds        : holdReducers,
  horizons     : horizonReducers,
  horizonStats : horizonStatReducers,
  jobs         : jobReducers,
  main         : mainViewReducers,
  notifications: notificationReducers,
  orders       : orderReducers,
  preAuth      : preAuthReducers,
  printers     : printerReducers,
  products     : productReducers,
  reports      : reportReducers,
  scrap        : scrapReducers,
  shipments    : shipmentReducers,
  settings     : settingReducers,
  templates    : templateReducers,
  users        : userReducers,
  holdBins     : holdBinsReducers,
  jobLocations : jobLocationsReducers,
  roles        : roleReducers,
};

const reducer = combineReducers(reducers);
// const devReducer = compose(combineReducers)(reducers);
// const prodReducer = combineReducers(reducers);

export function rootReducer(state: any, action: any) {
  return reducer(state, action);
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/index.ts